/* eslint-disable max-len */
/* eslint-disable @scandipwa/scandipwa-guidelines/file-structure */
/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/scandipwa
 * @link https://github.com/scandipwa/scandipwa
 */

import PropTypes from 'prop-types';

const propTypes = (member) => ({
    ...member,
    paymentMethodCode: PropTypes.string.isRequired
});

const setPaymentMethodFromReducer = (args) => {
    const { paymentMethodCode } = args[0];
    const { selectedPaymentCode } = args[1];

    if (selectedPaymentCode === '' && paymentMethodCode !== '') {
        return {
            selectedPaymentCode: paymentMethodCode
        };
    }

    return null;
};

const mapStateToProps = (args, callback, _instance) => {
    const [state] = args;

    return {
        ...callback(...args),
        paymentMethodCode: state.CheckoutFieldsReducer.paymentMethodCode
    };
};

export default {
    'Component/CheckoutPayments/Container': {
        'static-member': {
            propTypes,
            getDerivedStateFromProps: setPaymentMethodFromReducer
        }
    },
    'Component/CheckoutPayments/Container/mapStateToProps': {
        function: mapStateToProps
    }
};
